import { render, staticRenderFns } from "./LogoSignatureCentralizedSection.vue?vue&type=template&id=f964c822"
import script from "./LogoSignatureCentralizedSection.vue?vue&type=script&lang=ts"
export * from "./LogoSignatureCentralizedSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoSignatureCentralizedSection.vue?vue&type=style&index=0&id=f964c822&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports